function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { secondsToMilliseconds } from 'motion-utils';
import { GroupAnimation } from '../animation/GroupAnimation.mjs';
import { NativeAnimation } from '../animation/NativeAnimation.mjs';
import { NativeAnimationWrapper } from '../animation/NativeAnimationWrapper.mjs';
import { getValueTransition } from '../animation/utils/get-value-transition.mjs';
import { mapEasingToNativeEasing } from '../animation/waapi/easing/map-easing.mjs';
import { applyGeneratorOptions } from '../animation/waapi/utils/apply-generator.mjs';
import { chooseLayerType } from './utils/choose-layer-type.mjs';
import { css } from './utils/css.mjs';
import { getLayerName } from './utils/get-layer-name.mjs';
import { getViewAnimations } from './utils/get-view-animations.mjs';
import { hasTarget } from './utils/has-target.mjs';
var definitionNames = ["layout", "enter", "exit", "new", "old"];

function startViewAnimation(builder) {
  var update = builder.update,
      targets = builder.targets,
      defaultOptions = builder.options;

  if (!document.startViewTransition) {
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return update();

              case 2:
                resolve(new GroupAnimation([]));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  } // TODO: Go over existing targets and ensure they all have ids

  /**
   * If we don't have any animations defined for the root target,
   * remove it from being captured.
   */


  if (!hasTarget("root", targets)) {
    css.set(":root", {
      "view-transition-name": "none"
    });
  }
  /**
   * Set the timing curve to linear for all view transition layers.
   * This gets baked into the keyframes, which can't be changed
   * without breaking the generated animation.
   *
   * This allows us to set easing via updateTiming - which can be changed.
   */


  css.set("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
    "animation-timing-function": "linear !important"
  });
  css.commit(); // Write

  var transition = document.startViewTransition( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return update();

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  transition.finished.finally(function () {
    css.remove(); // Write
  });
  return new Promise(function (resolve) {
    transition.ready.then(function () {
      var generatedViewAnimations = getViewAnimations();
      var animations = [];
      /**
       * Create animations for each of our explicitly-defined subjects.
       */

      targets.forEach(function (definition, target) {
        // TODO: If target is not "root", resolve elements
        // and iterate over each
        var _iterator = _createForOfIteratorHelper(definitionNames),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            if (!definition[key]) continue;
            var _definition$key = definition[key],
                keyframes = _definition$key.keyframes,
                options = _definition$key.options;

            for (var _i = 0, _Object$entries = Object.entries(keyframes); _i < _Object$entries.length; _i++) {
              var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                  valueName = _Object$entries$_i[0],
                  valueKeyframes = _Object$entries$_i[1];

              if (!valueKeyframes) continue;

              var valueOptions = _objectSpread(_objectSpread({}, getValueTransition(defaultOptions, valueName)), getValueTransition(options, valueName));

              var type = chooseLayerType(key);
              /**
               * If this is an opacity animation, and keyframes are not an array,
               * we need to convert them into an array and set an initial value.
               */

              if (valueName === "opacity" && !Array.isArray(valueKeyframes)) {
                var initialValue = type === "new" ? 0 : 1;
                valueKeyframes = [initialValue, valueKeyframes];
              }
              /**
               * Resolve stagger function if provided.
               */


              if (typeof valueOptions.delay === "function") {
                valueOptions.delay = valueOptions.delay(0, 1);
              }

              valueOptions.duration && (valueOptions.duration = secondsToMilliseconds(valueOptions.duration));
              valueOptions.delay && (valueOptions.delay = secondsToMilliseconds(valueOptions.delay));
              var animation = new NativeAnimation(_objectSpread(_objectSpread({}, valueOptions), {}, {
                element: document.documentElement,
                name: valueName,
                pseudoElement: "::view-transition-".concat(type, "(").concat(target, ")"),
                keyframes: valueKeyframes
              }));
              animations.push(animation);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      /**
       * Handle browser generated animations
       */

      var _iterator2 = _createForOfIteratorHelper(generatedViewAnimations),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var animation = _step2.value;
          if (animation.playState === "finished") continue;
          var effect = animation.effect;
          if (!effect || !(effect instanceof KeyframeEffect)) continue;
          var pseudoElement = effect.pseudoElement;
          if (!pseudoElement) continue;
          var name = getLayerName(pseudoElement);
          if (!name) continue;
          var targetDefinition = targets.get(name.layer);

          if (!targetDefinition) {
            var _animationTransition$;

            /**
             * If transition name is group then update the timing of the animation
             * whereas if it's old or new then we could possibly replace it using
             * the above method.
             */
            var transitionName = name.type === "group" ? "layout" : "";

            var animationTransition = _objectSpread({}, getValueTransition(defaultOptions, transitionName));

            animationTransition.duration && (animationTransition.duration = secondsToMilliseconds(animationTransition.duration));
            animationTransition = applyGeneratorOptions(animationTransition);
            var easing = mapEasingToNativeEasing(animationTransition.ease, animationTransition.duration);
            effect.updateTiming({
              delay: secondsToMilliseconds((_animationTransition$ = animationTransition.delay) !== null && _animationTransition$ !== void 0 ? _animationTransition$ : 0),
              duration: animationTransition.duration,
              easing: easing
            });
            animations.push(new NativeAnimationWrapper(animation));
          } else if (hasOpacity(targetDefinition, "enter") && hasOpacity(targetDefinition, "exit") && effect.getKeyframes().some(function (keyframe) {
            return keyframe.mixBlendMode;
          })) {
            animations.push(new NativeAnimationWrapper(animation));
          } else {
            animation.cancel();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      resolve(new GroupAnimation(animations));
    });
  });
}

function hasOpacity(target, key) {
  var _target$key;

  return target === null || target === void 0 ? void 0 : (_target$key = target[key]) === null || _target$key === void 0 ? void 0 : _target$key.keyframes.opacity;
}

export { startViewAnimation };